// extracted by mini-css-extract-plugin
module.exports = {"container":"HotkeysList_container__1OtK7"};